import React from 'react';
import type { TrackingPropsInterface } from '../../utils/enums/enums';
import { DEFAULT_NEXT_TEXT, DEFAULT_PREVIOUS_TEXT } from '../../utils/i18nConstants';

export enum ACarouselArrowDirection {
  Right = 'Right',
  Left = 'Left',
}

export interface ACarouselArrowI18nProviderProps {
  next?: string;
  previous?: string;
}

export interface ACarouselArrowProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  direction?: ACarouselArrowDirection;
  disabled?: boolean;
  transparent?: boolean;
  trackingProperties?: TrackingPropsInterface;
  i18nProperties?: ACarouselArrowI18nProviderProps;
}
